
define('text!common/views/commercial/creatives/manual-single-button.html',[],function () { return '<a class="lineitem__cta button button--tertiary button--small"\n   href="<%=clickMacro%><%=offerUrl%>"\n   data-link-name="merchandising-<%=offerTitle%>-link">\n    <%=offerLinkText%><%=arrowRight%>\n</a>\n';});

